import React from "react";
import {useInternalDataContext} from "../../../../MaterialModalProvider";
import {TemplateView} from "../../../../types";
import {TemplateBrowser} from "../../../../components/template/TemplateBrowser";
import {TemplateItemPresenter} from "./TemplateItemPresenter";

export function TemplateTabContent() {
	const {materialChangeData} = useInternalDataContext()
	const {
		view,
		breadcrumbs,
		browserData,
		itemPresenterData
	} = materialChangeData.templates

	return (
		<>
			{view === TemplateView.BROWSER ? <TemplateBrowser {...{browserData, breadcrumbs}}/> : null}
			{view === TemplateView.ITEM_PRESENTER ? <TemplateItemPresenter {...{itemPresenterData, breadcrumbs}}/> : null}
		</>
	)
}